// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__12-1i","approved":"Status_approved__3AwfQ","rejected":"Status_rejected__cV9_l","expired":"Status_expired___UEa2","label":"Status_label__Bqsh5"};